// @flow strict

import * as React from 'react';
import styles from './styles.scss';
import PageContentBlock from '../../internal/PageContentBlock';

type PropTypes = {|
  children: React.ChildrenArray<React.Element<*>>,
|};

const BlockWrapper = ({ children }: PropTypes) => (
  <PageContentBlock removePadding removeMargin className={styles.marginWrapper}>
    <div className={styles.blocksWrapper}>{children}</div>
  </PageContentBlock>
);

export default BlockWrapper;
